import { memo, useEffect, useState, useContext, useRef } from 'react';
import { Link, useLocation } from "react-router-dom";
import TextTruncate from 'react-text-truncate';
import { useCookies } from 'react-cookie'
import { useTranslation } from "react-i18next";

import '../css/Product.css'

import { priceFormat } from "../../inc/Fetch";
import { Img, AddToCart } from "../Elements";
import { AppContext } from "../../../Context";
import { MdAddShoppingCart } from "react-icons/md";


export default function Product({ data }) {
    
    
    
    const { t } = useTranslation();
    const location = useLocation();
    
    const {user, siteData, cartData} = useContext(AppContext);
    const [userinfo, setuserinfo] = user;
    const [siteInfo, setsiteInfo] = siteData;
    const [cart, setcart] = cartData;
    
    let selected = cart?.filter(r => r?._id == data?._id);


    return (
        <div className={`product ${selected?.length ? "cartSelected" : ""}`}>
            
            <Link className='productLink' to={`/productPop/${data?._id}`} state={{ previousLocation: location }} >

                {data?.tag ? <span style={data?.tag_color ? {backgroundColor:data?.tag_color } : false} className='productTag'>{data?.tag}</span> : ""}
                <Img src={`img/300x250/${data?.img[0]}`} />
                {data?.pid ? 
                    <div className='moreSmallProdInfo'>
                        {t("product_id")}: {data?.pid}
                    </div>
                :false}

                <h3>{data?.title}</h3>

                <p>{data?.short?.substring(0, 150)}</p>

                {siteInfo?.settings?.show_prices?.val == 1 || (siteInfo?.settings?.show_prices?.val == 0 && userinfo?._id) ? <dl>
                    {userinfo?.settings?.discount ?
                        <>
                            <dd >{priceFormat(data?.price?.$numberDecimal - data?.price?.$numberDecimal * (userinfo?.settings?.discount / 100) )}</dd>
                            <dt>{global?.currency}</dt>
                            <dd style={{textDecoration:"line-through", color:"#999", fontSize:12}}>{priceFormat(data?.price?.$numberDecimal)} {global?.currency}</dd>
                        </>
                    :
                        <>
                            <dd >{priceFormat(data?.price?.$numberDecimal)}</dd>
                            <dt>{global?.currency}</dt>
                        </>
                    }
                </dl>: false}

                
            </Link>
            
            <AddToCart showNum={true} data={data}/>
        </div>
    );
}
